<template>
    <section>
        <row class="g-4">
            <column md="4">
                <div class="text-base leading-snug font-semibold text-body">
                    {{ trans('users.edit_user.field.language.label') }}
                </div>
            </column>
            <column md="8">
                <div class="rounded-card border border-panel-border bg-panel p-4">
                    <jet-select
                        :model-value="modelValue"
                        :horizontal="false"
                        :invalidFeedback="error"
                        :label="trans('users.edit_user.field.language.label')"
                        :options="supportedLanguages"
                        :resettable="false"
                        class="mb-0"
                        @update:model-value="$emit('update:modelValue', $event)"
                    />
                </div>
            </column>
        </row>
    </section>
</template>

<script setup>
import JetSelect from '@/Jetstream/Select.vue';
import { trans } from '@/mixins/i18n.js';
import { getLabelForLocale } from '@/Utils/getLabelForLocale.ts';
import { usePage } from '@inertiajs/vue3';
import { computed } from 'vue';

defineProps({
    modelValue: String,
    error: String,
});

defineEmits(['update:modelValue']);

const page = usePage();

const supportedLanguages = computed(() =>
    page.props.supported_locales.map((key) => ({
        value: key,
        label: getLabelForLocale(key),
    })),
);
</script>
